export default __webpack_public_path__ + "static/media/AC-DC-24x24.2ee1d156.svg";